import {BaseCriteriaModel} from "../../base-criteria.model";
import {Optional} from "typescript-optional";

export class ProjectLoginSubjectQueryCriteriaClass extends BaseCriteriaModel{
  project_hdr_guid: Optional<string> = Optional.empty();
  project_line_guid: Optional<string> = Optional.empty();
  login_subject_guid: Optional<string> = Optional.empty();
  namespace: Optional<string> = Optional.empty();
  module_guid: Optional<string> = Optional.empty();
  applet_guid: Optional<string> = Optional.empty();
  link_type: Optional<string> = Optional.empty();
  rank: Optional<string> = Optional.empty();
  created_by_subject_guid: Optional<string> = Optional.empty();
  updated_by_subject_guid: Optional<string> = Optional.empty();
}

export class ProjectLoginSubjectQueryCriteriaModel {
  query = '';

  constructor(criteria: ProjectLoginSubjectQueryCriteriaClass) {

    if (!criteria) {
      return;
    }

    this.query += criteria.project_hdr_guid.filter(x => x !== '').map(x => '&project_hdr_guid=' + x).orElse('');
    this.query += criteria.project_line_guid.filter(x => x !== '').map(x => '&project_line_guid=' + x).orElse('');
    this.query += criteria.login_subject_guid.filter(x => x !== '').map(x => '&login_subject_guid=' + x).orElse('');
    this.query += criteria.namespace.filter(x => x !== '').map(x => '&namespace=' + x).orElse('');
    this.query += criteria.module_guid.filter(x => x !== '').map(x => '&module_guid=' + x).orElse('');
    this.query += criteria.applet_guid.filter(x => x !== '').map(x => '&applet_guid=' + x).orElse('');
    this.query += criteria.link_type.filter(x => x !== '').map(x => '&link_type=' + x).orElse('');
    this.query += criteria.rank.filter(x => x !== '').map(x => '&rank=' + x).orElse('');
    this.query += criteria.created_by_subject_guid.filter(x => x !== '').map(x => '&created_by_subject_guid=' + x).orElse('');
    this.query += criteria.updated_by_subject_guid.filter(x => x !== '').map(x => '&updated_by_subject_guid=' + x).orElse('');

    this.query += '&status=' + criteria.status;
    this.query += '&orderBy=' + criteria.orderBy;
    this.query += '&order=' + criteria.order;
    this.query += '&offset=' + criteria.offset + '&limit=' + criteria.limit;
  }

}
